import { render, staticRenderFns } from "./commentaire.vue?vue&type=template&id=05ef7136"
import script from "./commentaire.js?vue&type=script&lang=js&external"
export * from "./commentaire.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports